module.exports = __webpack_public_path__ + "static/media/ge.d3665bf1.svg";